import { render } from "./RecordTestVideo.vue?vue&type=template&id=254e273c"
import script from "./RecordTestVideo.vue?vue&type=script&lang=js"
export * from "./RecordTestVideo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__